<ndt-account-phone-number-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [phoneNumberPrivileges]="phoneNumberPrivileges$ | async"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
   [isSystemUser]="isSystemUser$ | async"
   (numberReleased)="onNumberReleased($event)"
   (numberDeleted)="onNumberDeleted($event)"
></ndt-account-phone-number-register-view>
